// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2XaR7","inner":"Form_inner__2Zhrf","range":"Form_range__3JO5_","name":"Form_name__fjCMH","actions":"Form_actions__YSi0i"};